import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DoCheck,
  Input,
  OnDestroy,
  Optional,
} from '@angular/core';
import { AbstractControlDirective, NgControl } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { startWith, Subject, takeUntil } from 'rxjs';
import { formFieldAnimations } from './form-field-indicator-animations';
import { FormFieldComponent } from './form-field.component';

@Component({
    selector: 'lui-form-field-indicator',
    template: `
    <div class="field-indicator" *ngIf="touched && status" @indicator>
      <ng-container [ngSwitch]="status">
        <ng-container *ngSwitchCase="'VALID'">
          <mat-icon [svgIcon]="'tick'"></mat-icon>
        </ng-container>
        <ng-container *ngSwitchCase="'INVALID'">
          <mat-icon [svgIcon]="'exclaim'"></mat-icon>
        </ng-container>
      </ng-container>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [formFieldAnimations.indicator],
    standalone: false
})
export class FormFieldIndicatorComponent
  implements AfterViewInit, DoCheck, OnDestroy
{
  @Input() valid!: boolean;

  _ngControl!: NgControl | AbstractControlDirective | null;

  touched!: boolean;
  status!: string;

  _destroy = new Subject<void>();

  constructor(
    @Optional() private matFormField: MatFormField | null,
    @Optional() private luiFormField: FormFieldComponent | null,
    private _cd: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    const formField = this.matFormField || this.luiFormField;

    if (formField) {
      this._ngControl =
        formField instanceof MatFormField
          ? formField._control.ngControl
          : formField.control.ngControl;
    }

    if (this._ngControl && this._ngControl.statusChanges) {
      this._ngControl.statusChanges
        .pipe(takeUntil(this._destroy), startWith(this._ngControl.status))
        .subscribe((v) => {
          if (this._ngControl?.untouched) {
            Promise.resolve().then(() => {
              this.status = v;
              this.touched = false;
              this._cd.markForCheck();
            });
          } else {
            this.status = v;
            this._cd.markForCheck();
          }
        });
    }
  }

  ngOnDestroy(): void {
    this._destroy.next();
    this._destroy.complete();
  }

  ngDoCheck(): void {
    if (!this.touched && this._ngControl && this._ngControl.touched) {
      this.touched = true;
      this._cd.markForCheck();
    }
  }
}
